import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { QESButton, QESTextInput } from "@app/shared/qes-standards"
import { FC, useContext, useRef } from "react"

interface ZipPublishProps {
  onPublish: (comment?: string) => void;
}

export const ZipProjectPublishFlyout: FC<ZipPublishProps> = (props: ZipPublishProps) => {
  const commentRef = useRef<HTMLInputElement>(null);
  const flyoutContext = useContext(FlyoutContext);

  const handlePublish = () => {
    props.onPublish(commentRef.current.value);
    flyoutContext.handleCloseFlyout();
  }

  return (
    <>
      <div className="col-7">
        <QESTextInput
          label="Publish Tag"
          testId="zip-project-publish-flyout__comment-input"
          defaultValue=""
          descriptiveText="This could help you recognize the time slice later."
          qesRef={commentRef}
          maxLength={50}
        />
      </div>

      <FlyoutFooter
        submitButton={
          <QESButton
            qesType="primary"
            qesTestId="zip-project-publish-flyout__publish-button"
            onClick={handlePublish}
          >
            Publish
          </QESButton>
        }
      />
    </>
  )
};
